import * as React from 'react';
import * as Classes from '../common/classes';
import classNames from 'classnames';
import { BaseProps } from '../common/props';
import { InverseBgProvider } from '../theme/InverseBg';
import { CheckboxButton } from '../checkbox/CheckboxButton';

type DefaultGroupContainerProps = Omit<BaseProps, 'title'> & {
  title?: React.ReactNode | string;
  /**
   * Pokud je true, nezalamuje se dlouhý text do více řádků a aplikují se tři tečky, sndardně se text zalamuje.
   */
  noWrap?: boolean;
  extra?: React.ReactNode;
  headerContent?: React.ReactNode;
  banner?: React.ReactNode;
  noPadding?: boolean;
  inverse?: boolean;
  bodyClassName?: string;
  /**
   * Propsy pro checkbox
   */
  checkable?: boolean;
  checked?: boolean;
  onCheck?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disabled?: boolean;
};
export const DefaultGroupContainer: React.FC<DefaultGroupContainerProps> = ({
  className,
  style,
  title,
  headerContent,
  noWrap,
  extra,
  children,
  noPadding,
  banner,
  bodyClassName,
  inverse,
  checkable,
  checked,
  onCheck,
  disabled,
}) => {
  return (
    <div
      className={classNames(className, Classes.DEFAULT_GROUP_CONTAINER, {
        [Classes.GROUP_CONTAINER_EMPTY]: !children,
        [Classes.GROUP_CONTAINER_INVERSE]: inverse,
      })}
      style={style}
    >
      {(title || extra || headerContent) && (
        <InverseBgProvider inverse={!inverse}>
          <div className={Classes.GROUP_CONTAINER_HEADER}>
            {(title || extra) && (
              <>
                <div
                  className={classNames(Classes.GROUP_CONTAINER_HEADER_TITLE, {
                    [Classes.GROUP_CONTAINER_HEADER_TITLE_NO_WRAP]: noWrap,
                  })}
                >
                  {checkable === true && (
                    <CheckboxContainer
                      checked={checked}
                      onCheck={onCheck}
                      disabled={disabled}
                    />
                  )}
                  {title}
                </div>
                <div className={Classes.GROUP_CONTAINER_HEADER_EXTRA}>
                  {extra}
                </div>
              </>
            )}
            {headerContent && (
              <div className={Classes.GROUP_CONTAINER_HEADER_CONTENT}>
                {checkable === true && !title && !extra && (
                  <CheckboxContainer
                    checked={checked}
                    onCheck={onCheck}
                    disabled={disabled}
                  />
                )}
                {headerContent}
              </div>
            )}
          </div>
        </InverseBgProvider>
      )}
      {banner}
      {children && (
        <div
          className={classNames(
            Classes.GROUP_CONTAINER_BODY,
            {
              [Classes.GROUP_CONTAINER_BODY_PADDING]: !noPadding,
            },
            bodyClassName
          )}
        >
          {children}
        </div>
      )}
    </div>
  );
};

const CheckboxContainer: React.FC<{
  checked?: boolean;
  onCheck?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  disabled?: boolean;
}> = ({ checked, onCheck, disabled }) => {
  return (
    <div className={Classes.GROUP_CHECKER_CONT}>
      <CheckboxButton
        // @ts-ignore
        onChange={onCheck}
        checked={checked}
        disabled={disabled}
      />
    </div>
  );
};
